module.exports = __webpack_public_path__ + "media/assets/owl-51474e37383a0e3cbf4a0a5a65876ab8.png";